export default __webpack_public_path__ + "static/media/pdf-white.e1ea36bd.svg";